export const merge = (...obj) => {
  return Object.assign({}, ...obj);
};
